import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export function SectionCard({
  title,
  children,
  className,
}: {
  title?: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section className={cn('rounded-lg border bg-background p-4 shadow-xs', className)}>
      {title ? <h2 className="text-base font-semibold text-foreground">{title}</h2> : null}
      {children}
    </section>
  );
}
